import React, { useMemo, useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import "tailwindcss/tailwind.css";
import { Empty } from "antd";
// import { ArrowRightOutlined } from "@ant-design/icons";
import Vectorsorting from "../../assets/Vectorsorting.svg";
// import { Image } from "antd";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import ShimmerLoader from "../../loading";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const UserRightsTable = ({ tabledata, handleCheckboxChange, handlePasswordChange, isEtaEnable }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [flag, setflag] = useState(false);
  const is_lahloob = useSelector(
    (state) => state.login?.user?.result?.is_lahloob
  );
      const userData = useSelector((state) => state?.login?.user?.result);
  
  const [visiblePasswords, setVisiblePasswords] = useState({});
  const [passwordModalData, setPasswordModalData] = useState({
    open: false,
    userId: null,
    password: "",
  });

  const data = useMemo(() => {
    if (Array.isArray(tabledata)) {
      return tabledata;
    } else if (tabledata && typeof tabledata === "object") {
      return [];
    }
    return [];
  }, [tabledata]);
  console.log("Length==>", data?.length);

  useEffect(() => {
    if (data.length === 0 && !flag) {
      const timer = setTimeout(() => {
        setflag(true);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [data, flag]);

   const columns = useMemo(
    () => [
      {
        Header: t("Users"),
        accessor: "name",
        Cell: ({ row }) => (
        <div className="text-start">{`${row.original.name} (${row.original.phone ? row.original.phone : row.original.email})`}</div>
      ),
      },
      {
        Header: t("Dashboard"),
        accessor: "is_dashboard_show",
        Cell: ({ row }) => (
          <input
            type="checkbox"
            name="is_dashboard_show"
            className="cursor-pointer w-4 h-4 accent-[#465466]"
            checked={row.original.is_dashboard_show}
            onChange={(e) => {
              handleCheckboxChange(row.original.retailer_user_id, "is_dashboard_show", e.target.checked);
            }}
          />
        ),
      },
      {
        Header: t("View Orders"),
        accessor: "show_orders",
        Cell: ({ row }) => (
          <input
            type="checkbox"
            name="show_orders"
            className="cursor-pointer w-4 h-4 accent-[#465466]"
            checked={row.original.show_orders}
            onChange={(e) => {
              handleCheckboxChange(row.original.retailer_user_id, "show_orders", e.target.checked);
            }}
          />
        ),
      },
      {
        Header: t("Credit"),
        accessor: "show_credit",
        Cell: ({ row }) => (
          <input
            type="checkbox"
            name="show_credit"
            className="cursor-pointer w-4 h-4 accent-[#465466]"
            checked={row.original.show_credit}
            onChange={(e) => {
              handleCheckboxChange(row.original.retailer_user_id, "show_credit", e.target.checked);
            }}
          />
        ),
      },
      {
        Header: t("Favorites"),
        accessor: "is_favorite_show",
        Cell: ({ row }) => (
          <input
            type="checkbox"
            name="is_favorite_show"
            className="cursor-pointer w-4 h-4 accent-[#465466]"
            checked={row.original.is_favorite_show}
            onChange={(e) => {
              handleCheckboxChange(row.original.retailer_user_id, "is_favorite_show", e.target.checked);
            }}
          />
        ),
      },
      {
        Header: t("All Category"),
        accessor: "is_all_categ_show",
        Cell: ({ row }) => (
          <input
            type="checkbox"
            name="is_all_categ_show"
            className="cursor-pointer w-4 h-4 accent-[#465466]"
            checked={row.original.is_all_categ_show}
            onChange={(e) => {
              handleCheckboxChange(row.original.retailer_user_id, "is_all_categ_show", e.target.checked);
            }}
          />
        ),
      },

      {
        Header: t("Discount"),
        accessor: "is_allow_discount",
        Cell: ({ row }) => (
          <input
            type="checkbox"
            name="is_allow_discount"
            className="cursor-pointer w-4 h-4 accent-[#465466]"
            checked={row.original.is_allow_discount}
            onChange={(e) => {
              handleCheckboxChange(row.original.retailer_user_id, "is_allow_discount", e.target.checked);
            }}
          />
        ),
      },

      {
        Header: t("Product Short Code"),
        accessor: "is_allow_product_shortcut",
        Cell: ({ row }) => (
          <input
            type="checkbox"
            name="is_allow_product_shortcut"
            className="cursor-pointer w-4 h-4 accent-[#465466]"
            checked={row.original.is_allow_product_shortcut}
            onChange={(e) => {
              handleCheckboxChange(row.original.retailer_user_id, "is_allow_product_shortcut", e.target.checked);
            }}
          />
        ),
      },
      {
        Header: t("Opening Cash"),
        accessor: "is_allow_opening_cash",
        Cell: ({ row }) => (
          <input
            type="checkbox"
            name="is_allow_opening_cash"
            className="cursor-pointer w-4 h-4 accent-[#465466]"
            checked={row.original.is_allow_opening_cash}
            onChange={(e) => {
              handleCheckboxChange(row.original.retailer_user_id, "is_allow_opening_cash", e.target.checked);
            }}
          />
        ),
      },
      {
        Header: t("Allow Sale Negative"),
        accessor: "is_allow_negative_sale",
        Cell: ({ row }) => (
          <input
            type="checkbox"
            name="is_allow_negative_sale"
            className="cursor-pointer w-4 h-4 accent-[#465466]"
            checked={row.original.is_allow_negative_sale}
            onChange={(e) => {
              handleCheckboxChange(row.original.retailer_user_id, "is_allow_negative_sale", e.target.checked);
            }}
          />
        ),
      },
      {
        Header: t("Allow Add Product (Cashier)"),
        accessor: "is_allow_add_product",
        Cell: ({ row }) => (
          <input
            type="checkbox"
            name="is_allow_negative_sale"
            className="cursor-pointer w-4 h-4 accent-[#465466]"
            checked={row.original.is_allow_add_product}
            onChange={(e) => {
              handleCheckboxChange(row.original.retailer_user_id, "is_allow_add_product", e.target.checked);
            }}
          />
        ),
      },
      {
        Header: t("Tax Price Included"),
        accessor: "is_tax_price_inclusive",
        Cell: ({ row }) => (
          <input
            type="checkbox"
            disabled={userData?.is_sub_store || userData?.is_warehouse}
            name="is_allow_negative_sale"
            className="cursor-pointer w-4 h-4 accent-[#465466]"
            checked={(userData?.is_sub_store || userData?.is_warehouse) ? false :row.original.is_tax_price_inclusive}
            onChange={(e) => {
              handleCheckboxChange(row.original.retailer_user_id, "is_tax_price_inclusive", e.target.checked);
            }}
          />
        ),
      },
{
        Header: t("Add Product Group (Cashier)"),
        accessor: "is_allow_edit_product_group",
        Cell: ({ row }) => (
          <input
            type="checkbox"
            disabled={userData?.is_sub_store || userData?.is_warehouse}
            name="is_allow_edit_product_group"
            className="cursor-pointer w-4 h-4 accent-[#465466]"
            checked={(userData?.is_sub_store || userData?.is_warehouse) ? false :row.original.is_allow_edit_product_group}
            onChange={(e) => {
              handleCheckboxChange(row.original.retailer_user_id, "is_allow_edit_product_group", e.target.checked);
            }}
          />
        ),
      },
      {
        Header: t("Show Total Credit Amount"),
        accessor: "is_show_total_credit",
        Cell: ({ row }) => (
          <input
            type="checkbox"
            name="is_show_total_credit"
            className="cursor-pointer w-4 h-4 accent-[#465466]"
            checked={(userData?.is_sub_store || userData?.is_warehouse) ? false :row.original.is_show_total_credit}
            onChange={(e) => {
              handleCheckboxChange(row.original.retailer_user_id, "is_show_total_credit", e.target.checked);
            }}
          />
        ),
      },
      {
        Header: t("Password"),
        accessor: "is_password_restrict",
        Cell: ({ row }) => (
          <input
            type="checkbox"
            name="is_password_restrict"
            className="cursor-pointer w-4 h-4 accent-[#465466]"
            checked={row.original.is_password_restrict}
            onChange={(e) => {
              handleCheckboxChange(row.original.retailer_user_id, "is_password_restrict", e.target.checked);
            }}
          />
        ),
      },
      {
        Header: (
          <div className="text-center text-balance" title={t("POS Password")} style={{ maxWidth: '100px' }}>
            {t("Security Password")}
          </div>
        ),
        accessor: "pos_password",
        headerClassName: "text-center ms-2",
        width: 90,
        Cell: ({ row }) => {
          const userId = row.original.retailer_user_id;
          const isRestricted = row.original.is_password_restrict;
          const passwordValue = row.original.pos_password || "";
          const isPasswordVisible = visiblePasswords[userId] || false;

          const toggleVisibility = () => {
            setVisiblePasswords(prev => ({
              ...prev,
              [userId]: !prev[userId]
            }));
          };

          return (
            <div className="flex">
              {isRestricted ? (<div className="flex border justify-between align-middle border-gray-300 rounded px-2 py-1 w-32 text-sm">
                <div onClick={() => setPasswordModalData({ open: true, userId, passwordValue })} className="w-3/4 mt-1 cursor-pointer">
                  {visiblePasswords[userId] ? passwordValue : (passwordValue != '' ? "******" : '')}
                </div>
                <button
                  type="button"
                  onClick={toggleVisibility}
                  className="ml-2 text-gray-500 hover:text-gray-800 focus:outline-none"
                >
                  {visiblePasswords[userId] ? <FaEyeSlash /> : <FaEye />}
                </button>

              </div>
              ) : (
                <span className="text-gray-400">--</span>
              )}
            </div>
          );
        },
      }

       ],
    [t, tabledata, visiblePasswords]);



  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 500 },
    },
    useSortBy,
    usePagination
  );

  return (
    <div
      className="container mx-auto float-left h-[100%]"
      style={{ maxWidth: "100%" }}
    >
      {passwordModalData.open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded shadow-md w-[300px]">
            <h2 className="text-lg font-semibold mb-4">{t("Enter Security Password")}</h2>
            <input
              type="text"
              className="border border-gray-300 px-3 py-2 w-full mb-4 rounded"
              value={passwordModalData.password}
              onChange={(e) =>
                setPasswordModalData((prev) => ({
                  ...prev,
                  password: e.target.value,
                }))
              }
              placeholder={t("Enter Password")}
            />
            <div className="flex justify-end gap-2">
              <button
                onClick={() => setPasswordModalData({ open: false, userId: null, password: "" })}
                className="px-4 py-1  bg-white text-primaryBlue font-semibold rounded-lg inline border border-primaryBlue"
              >
                {t("Cancel")}
              </button>
              <button
                onClick={() => {
                  handlePasswordChange(passwordModalData.userId, passwordModalData.password);
                  setPasswordModalData({ open: false, userId: null, password: "" });
                }}
                className="px-4 py-1 rounded-lg font-semibold bg-primaryBlue text-white"
              // : "bg-primaryBlue text-white opacity-50 cursor-not-allowed"
              >
                {t("Save")}
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="flex flex-col h-full items-center">
        {tabledata?.length === 0 && flag === false ? (
          <div className="h-screen w-[90%] mt-2 ms-4">
            <ShimmerLoader />
          </div>
        ) : (
          <div className="overflow-x-auto scrollbar-thin w-full">
            {page.length === 0 ? (<>
              <Empty className="mt-16" description={t("No users found. Please add a user to get started.")} />
              <div className="flex justify-center w-full items-center">


                <button
                  onClick={() => navigate("/settings/usermanagement")}
                  className={`w-36 h-10 rounded-lg font-semibold self-center mt-5 ${
                    // hasChanges ?
                    "bg-primaryBlue text-white"
                    // : "bg-primaryBlue text-white opacity-50 cursor-not-allowed"
                    }`}
                // disabled={!hasChanges}
                >
                  {t("Add Users")}
                </button>
              </div>
            </>) : (
              <table
                {...getTableProps()}
                className="mt-7 overflow-hidden rounded-lg font-normal w-full min-w-[800px] sm:w-[97.6%] md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] min-h-auto h-full"
                style={{
                  direction: i18n.language === "ar" ? "rtl" : "ltr",
                }}
              >
                <thead className="bg-[#78CFEC66] text-sm font-semibold">
                  {headerGroups.map((headerGroup) => {
                    const { key: headerKey, ...headerGroupProps } = headerGroup.getHeaderGroupProps();
                    return (
                      <tr key={headerKey} {...headerGroupProps}>
                        {headerGroup.headers.map((column) => {
                          const { key: columnKey, ...columnProps } = column.getHeaderProps(column.getSortByToggleProps());
                          return (
                            <th
                              key={columnKey}
                              {...columnProps}
                              className={`py-3 px-4 whitespace-nowrap ${i18n.language === "ar" ? "text-right" : "text-left"
                                }`}
                            >
                              <div className="flex items-center justify-start">
                                {column.render("Header")}
                                <span>
                                  {column.isSorted && (
                                    <img
                                      src={Vectorsorting}
                                      className={column.isSortedDesc ? "" : "rotate-180"}
                                      style={{ minHeight: 10, minWidth: 10 }}
                                      alt="NA"
                                    />
                                  )}
                                </span>
                              </div>
                            </th>
                          );
                        })}
                      </tr>
                    );
                  })}
                </thead>
                <tbody {...getTableBodyProps()} className="bg-[#F7F9FD] text-left">
                  {page.map((row) => {
                    prepareRow(row);
                    const { key: rowKey, ...rowProps } = row.getRowProps();
                    return (
                      <tr
                        key={rowKey}
                        {...rowProps}
                        className="relative hover:bg-white transition duration-300 border-b border-gray-300 cursor-pointer"
                      >
                        {row.cells.map((cell) => {
                          const { key: cellKey, ...cellProps } = cell.getCellProps();
                          return (
                            <td
                              key={cellKey}
                              {...cellProps}
                              className={`p-4 px-4 text-[#272728] text-sm font-normal ${i18n.language === "ar" ? "text-right" : "text-left"
                                } ${cell.column.id === "profit" ? "min-w-[100px]" : ""}`}
                            >
                              {cell.render("Cell")}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>

        )}

      </div>
    </div>
  );
};

export default UserRightsTable;
